/**
 * ページ内アンカーのスムーススクロール機能
 * 固定ヘッダーの高さを考慮してスクロール位置を調整
 * 他ページからアンカーリンク付きで遷移した場合も対応
 */
export const smoothScroll = () => {
	const header = document.querySelector('.l-header')

	if (!header) {
		return
	}

	// ヘッダーの高さを取得する関数
	const getHeaderHeight = () => {
		return header.offsetHeight
	}

	// アンカー位置までスクロールする関数
	const scrollToAnchor = (anchorId, behavior = 'smooth') => {
		if (!anchorId) {
			return
		}

		// ハッシュ内にクエリパラメータが含まれている場合（#design?tab=t-design）
		const hashParts = anchorId.split('?')
		const targetId = hashParts[0]

		const targetElement = document.getElementById(targetId)
		if (!targetElement) {
			return
		}

		const headerHeight = getHeaderHeight()

		// ターゲット要素の位置を取得
		const targetPosition =
			targetElement.getBoundingClientRect().top + window.pageYOffset

		// ヘッダーの高さ分を引いた位置にスクロール
		const scrollPosition = targetPosition - headerHeight

		// スクロール
		window.scrollTo({
			top: scrollPosition,
			behavior: behavior,
		})
	}

	// ページ読み込み時にハッシュがある場合の処理（他ページから遷移した場合）
	const handleInitialHash = () => {
		const hash = window.location.hash.replace('#', '')
		if (!hash) {
			return
		}

		// ハッシュ内にクエリパラメータが含まれている場合は、アンカーID部分のみを取得
		const hashParts = hash.split('?')
		const anchorId = hashParts[0]

		// タブ名の場合は処理しない（tabSwitch.jsで処理される）
		const tabNames = ['c-design', 'r-design', 't-design']
		if (tabNames.includes(anchorId)) {
			return
		}

		// DOM読み込み完了後にスクロール（画像読み込みなどでレイアウトが変わる可能性があるため）
		if (document.readyState === 'loading') {
			window.addEventListener('DOMContentLoaded', () => {
				// さらに少し遅延させてからスクロール（レイアウト確定を待つ）
				window.setTimeout(() => {
					scrollToAnchor(anchorId, 'auto')
				}, 100)
			})
		} else {
			// 既にDOM読み込み完了している場合
			window.setTimeout(() => {
				scrollToAnchor(anchorId, 'auto')
			}, 100)
		}
	}

	// 初期ハッシュ処理を実行
	handleInitialHash()

	// ページ内アンカーリンクを取得
	const anchorLinks = document.querySelectorAll('a[href^="#"]')

	anchorLinks.forEach((link) => {
		link.addEventListener('click', (e) => {
			const href = link.getAttribute('href')

			// 空のアンカー（#のみ）やtarget="_blank"の場合は処理しない
			if (
				href === '#' ||
				href === '' ||
				link.getAttribute('target') === '_blank'
			) {
				return
			}

			// アンカー先の要素を取得
			const targetId = href.substring(1)
			const targetElement = document.getElementById(targetId)

			if (!targetElement) {
				return
			}

			// デフォルトの動作をキャンセル
			e.preventDefault()

			// スクロール処理
			scrollToAnchor(targetId, 'smooth')
		})
	})
}
